export default {
  description:
    'Prześlij dokumenty potrzebne do weryfikacji Twojej firmy. Wymagane dokumenty są oznaczone; opcjonalne możesz dodać teraz lub później.',
  missing_one:
    'Brakuje jeszcze jednego wymaganego dokumentu. Możesz kontynuować: ten krok pozostanie otwarty, dopóki nie zostanie przesłany.',
  missing_few:
    'Brakuje jeszcze {{count}} wymaganych dokumentów. Możesz kontynuować: ten krok pozostanie otwarty, dopóki nie zostaną przesłane.',
  missing_many:
    'Brakuje jeszcze {{count}} wymaganych dokumentów. Możesz kontynuować: ten krok pozostanie otwarty, dopóki nie zostaną przesłane.',
  missing_other:
    'Brakuje jeszcze {{count}} wymaganych dokumentów. Możesz kontynuować: ten krok pozostanie otwarty, dopóki nie zostaną przesłane.',
  buttons: {
    back: 'Wstecz',
    next: 'Dalej',
    finish_later: 'Dokończ później',
  },
};
